import * as React from "react";
import * as main from "../../main.module.scss";
import * as gifts from "./style.module.scss";
export const Gifts = ({ widgetPrice, widgetFree }) => {
  return (
    <section className={gifts.gifts} id={"gifts"}>
      <div className="container">
        <h2 className={main.title}>6 подарков для<br/> участников марафона</h2>
        <p className={main.subtitle}>Набор для успешного школьного<br/> обучения вашего ребенка</p>
        <ul>
          <li>
            <a href="#giftsForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/gifts-1.png" alt=""/>
              <h3>Мастер-класс<br/> по&nbsp;домашнему заданию</h3>
              <p>Ваш ребенок научится делать домашнее задание легко, быстро и&nbsp;самостоятельно</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/gifts-2.png" alt=""/>
              <h3>Памятка про договор с&nbsp;ребенком</h3>
              <p>Как правильно договариваться с&nbsp;ребенком</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/gifts-3.png" alt=""/>
              <h3>Онлайн-курс<br/> ”Глобус на&nbsp;пальце”</h3>
              <p>Ребенок выучит все страны мира на&nbsp;карте за&nbsp;7&nbsp;дней</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/gifts-4.png" alt=""/>
              <h3>113 Карточек<br/> по&nbsp;математике</h3>
              <p>Легко запомните все базовые термины и&nbsp;определения программы по&nbsp;математике</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/gifts-5.png" alt=""/>
              <h3>123 Карточки<br/> по&nbsp;русскому языку</h3>
              <p>Быстро выучите все базовые правила грамматики и&nbsp;пунктуации</p>
            </a>
          </li>
          <li>
            <a href="#giftsForm">
              <img src="https://fs.advance.ru/landing-pages/marathon/mndu_kz/gifts-6.png" alt=""/>
              <h3>Гайд по негативной<br/> детской мотивации</h3>
              <p>Выстройте эффективные отношения с&nbsp;ребенком для&nbsp;продуктивного обучения</p>
            </a>
          </li>
        </ul>
        <div className={gifts.reg} id={"giftsForm"}>
          <h3>Откройте доступ к марафону и получите 6 полезных файлов</h3>
          { widgetFree  }
        </div>
      </div>
    </section>
  );
};
